import { render, staticRenderFns } from "./contacts-change-password.vue?vue&type=template&id=a7b33a38&"
import script from "./contacts-change-password.vue?vue&type=script&lang=js&"
export * from "./contacts-change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports